import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices"
import { Tooltip } from "@mui/material"
import { t } from "i18next"
import { getDataSourceToken } from "tweenly"
import { useAppSelector } from "../../../hooks/useRedux"

interface Props {
    // Raw field content (text value or image src). The indicator is shown only when
    // the content contains a data source attribute token ({slug/attribute}).
    content: string | undefined | null
    fontSize?: "inherit" | "small" | "medium" | "large"
}

const DataSourceIndicator = ({ content, fontSize = "small" }: Props) => {
    const token = getDataSourceToken(content)
    const asset = useAppSelector((state) =>
        token ? state.assets.data.find((a) => a.slug === token.slug) : undefined
    )

    if (!token) return null

    const name = asset?.name ?? token.slug

    return (
        <Tooltip title={t("editor:dataSource.indicatorTooltip", { name })}>
            <ElectricalServicesIcon color="disabled" fontSize={fontSize} />
        </Tooltip>
    )
}

export default DataSourceIndicator
